import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type Store = {
  close: () => void;
  isOpen: boolean;
  open: () => void;
  toggler: (state: boolean) => void;
};

export const createDropdownStore = (key: string) =>
  create<Store>()(
    persist(
      (set) => ({
        isOpen: false,
        fileLinks: [],

        open: () => {
          set({ isOpen: true });
        },

        close: () => {
          set({ isOpen: false });
        },

        toggler: (state) => {
          set({ isOpen: state });
        },
      }),
      {
        name: `dropdown-${key}`,
      },
    ),
  );
